import React, {useCallback, useEffect, useMemo} from 'react';
import {ListBoxOptionType} from '@flixbus/honeycomb-react';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {updateFilter} from '@/Pages/Home/store/slice';
import {getPartners} from '@/Pages/Partners/store/thunks';
import CalculationAutocompleteFilter from '../CalculationAutocompleteFilter/CalculationAutocompleteFilter';

const PartnersFilter: React.FC = () => {
  const partners = useAppSelector(({partners}) => partners.list);
  const dispatch = useAppDispatch();

  const options: ListBoxOptionType[] = useMemo(
    () =>
      (partners ?? [])
        .map(partner => ({
          title: partner.name,
          value: partner.id
        }))
        .sort((p1, p2) => p1.title.localeCompare(p2.title)),
    [partners]
  );

  const handleSelect = useCallback(
    (selectedOptions: ListBoxOptionType[]) => {
      const value = selectedOptions.map(option => option.value as string);
      dispatch(
        updateFilter({
          field: 'busPartnerIds',
          value
        })
      );
    },
    [dispatch]
  );

  useEffect(() => dispatch(getPartners()), [dispatch]);

  return (
    <CalculationAutocompleteFilter
      label="Partner(s)"
      options={options}
      handleSelect={handleSelect}
    />
  );
};

export default React.memo(PartnersFilter);
